import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/404/NotFoundPage'
import {Container} from 'react-bootstrap'
import MenuManager from '../components/menus/menu-manager'
import Dashboard from '../pages/manager/Dashboard'
// import Cards from '../pages/manager/card/Cards'
import Cardsaux from '../pages/manager/card/Cardsaux'
import CardEdit from '../pages/manager/card/CardEdit'
import Cards from '../pages/manager/signup/Cards'
import Input from '../pages/manager/Input'
import Counter from '../pages/manager/Counter'

export default function ManagerRouter () {   
    return (
        <Container className='cabecera'>
            <MenuManager/>
            <Routes>
                <Route path="/dashboard" element={<Dashboard/>}/>
                <Route path="/cards" element={<Cards/>}/>
                <Route path="/cardschange" element={<Cardsaux/>}/>
                <Route exact path="/card/:id" element={<CardEdit/>}/>
                <Route path="/input" element={<Input/>}/>
                <Route path="/counters" element={<Counter/>}/>
                <Route path="*" element={<NotFoundPage />}/>
            </Routes>
        </Container>
    )
}